import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import PLink from "../components/plink"

const PList = props => (
  <a
    href={props.to}
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#925FCF", display: `block`, marginBottom: "18px" }}
  >
    {props.children}{" "}
  </a>
)


const IndexPage = ({ data, recommendations }) => (
  <Layout>
    <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
    <p
      style={{
        color: `#42556a`,
        fontSize: `1.0rem`,
        marginBottom: `0.8rem`,
        textAlign: `justify`,
      }}
    >
      Yo !! Always Creating is a blog series where I mainly write about tools
      and technologies which I come across while creating new projects.
      Sometimes I like to write about new insights and principles gained from
      books or personal experience.
    </p>
    <h3
      style={{
        marginTop: "2em",
        fontSize: `1.3rem`,
        margin: `4rem 0 2rem`,
        fontWeight: `500`,
      }}
    >
      Latest Blogs
    </h3>
    <hr />
    {data.data.edges.map(({ node }) => (
      <div>
        <PLink
          link={node.frontmatter.path}
          title={node.frontmatter.title}
          date={node.frontmatter.date}
        />
      </div>
    ))}
    <h3
      style={{
        marginTop: "2em",
        fontSize: `1.3rem`,
        margin: `4rem 0 2rem`,
        fontWeight: `500`,
      }}
    >
      Latest Recommended Articles
    </h3>
    <hr />


    {data.recommendations.edges[0].node.frontmatter.articles.slice(Math.max(data.recommendations.edges[0].node.frontmatter.articles.length - 5, 1)).map(({ title, link }) => (
      <div>
        <PList
          to={link}
        >
          {title}
        </PList>

      </div>
    ))}
    <br /> <br />
    <br />
  </Layout>
)

export const pageQuery = graphql`
  query MainIndexQuery {
    
      data: allMarkdownRemark(limit: 5, filter: {frontmatter: {type: {eq: "Main"}}}, sort: {fields: [frontmatter___date], order: DESC}) {
        edges {
          node {
            id
            frontmatter {
              path
              title
              date(formatString: "MMMM DD, YYYY")
              author
            }
            excerpt
          }
        }
      }
      
      recommendations:allMarkdownRemark(  
          filter: { frontmatter: { title: { eq: "Recommendation" } } }
        ) {
          edges {
            node {
              excerpt
              frontmatter {
                articles {
                  description
                  title
                  link
                }
                
                title
              }
            }
          }
        }
  }
`

export default IndexPage
